import { render } from "./NotaFiscalServicoListagem.vue?vue&type=template&id=42f3efe6&scoped=true&ts=true"
import script from "./NotaFiscalServicoListagem.vue?vue&type=script&lang=ts"
export * from "./NotaFiscalServicoListagem.vue?vue&type=script&lang=ts"

import "./NotaFiscalServicoListagem.vue?vue&type=style&index=0&id=42f3efe6&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f3efe6"]])

export default __exports__